module.exports = __webpack_public_path__ + "static/img/emons-title.17000b99.svg";